import React, { useContext, useState, useReducer } from 'react'
import { Route } from 'react-router-dom'
import { GlobalContext } from 'globalContext'
import PageHeader from 'components/PageHeader'
import PageLoader from 'components/PageLoader'
import { Segment, Button, Icon, Header, Modal } from 'semantic-ui-react'
import ConsultarSefazForm from './ConsultarSefazForm'
import AnimatedModal from 'components/AnimatedModal'
import { DateTime } from 'luxon' 
import history from 'services/history'
import SwitchRouter from 'components/SwitchRouter'
import ConferenciaForm from './ConferenciaForm'
import ConferenciaResult from './ConferenciaResult'

const initialSefazFormValues = {
    empresa: '',
    cupom: ''
}

const initialConfFormValues = {
    empresa: '',
    dataInicial: '',
    dataFinal: ''
}

function formReducer(state, action) {
    if ('reset' in action) 
        return action.reset === 'sefaz' ? initialSefazFormValues : initialConfFormValues
    if (!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

function withMenu(Component, props) {
    return (
        <div className="row flex-grow-1 mt-2">
            <div className="col d-flex flex-column">
                <div className="row mx-0">
                    <div className="col">
                        <Header as='h3'>
                            <Icon.Group size='big'>
                                <Icon name='tasks' className='primary-color' />
                            </Icon.Group>
                            <Header.Content className='primary-color'>
                                Ações
                                <Header.Subheader className='secondary-color'>
                                    <strong>Escolha a ação desejada</strong>
                                </Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                </div>
                <div className="row flex-grow-1 flex-column">
                    <div className="col d-flex align-items-center flex-column justify-content-center">
                        <Button icon style={{ maxWidth: 300 }} className='w-50 btn-primary mt-2' onClick={() => history.push(`${props.path}/consultar-sefaz`)} color='blue' size='small' fluid>
                            <Icon name='search' /> Consultar cupom na sefaz
                        </Button>
                        <Button icon style={{ maxWidth: 300 }} className='w-50 btn-primary mt-2' onClick={() => history.push(`${props.path}/relatorios`)} color='blue' size='small' fluid>
                            <Icon name='clipboard list' /> Conferência
                        </Button>
                    </div>
                </div>
            </div>
            <Component {...props} />
        </div>
    )
}

export default function NFCE({ match: { path } }) {

    const [globalState] = useContext(GlobalContext)
    const [situacaoCupom, setSituacaoCupom] = useState(null)
    const [conferencia, setConferencia] = useState(null)
    const [showModal, setShowModal] = useState(false) 
    const [formSefaz, setFormSefaz] = useReducer(formReducer, initialSefazFormValues)
    const [formConferencia, setFormConferencia] = useReducer(formReducer, initialConfFormValues)

    function closeModal() {
        setFormSefaz({ reset: 'sefaz' })
        setShowModal(false)
    }

    const empresas = globalState.empresas ? globalState.empresas.filter(x => x.tipoNF === 'NFCE' && x.tipo === 'POSTO' ) : []
    const consultarSefazFormProps = { 
        empresas, 
        formSefaz, 
        setFormSefaz, 
        setSituacaoCupom, 
        setShowModal 
    }

    const conferenciaFormProps = {
        path,
        empresas,
        formConferencia,
        setFormConferencia,
        setConferencia
    }

    const conferenciaResultProps = {
        conferencia,
        setConferencia,
        empresas,
        path
    }

    return (
        <PageLoader active={globalState.empresas === null}>

            <div id="conferencia-nfce" className='page-content'> 
                <PageHeader />
                <Segment className='subcontent py-0'>
                    <SwitchRouter>
                        <Route exact path={`${path}/consultar-sefaz`} render={props => withMenu(ConsultarSefazForm, { ...props, path, ...consultarSefazFormProps}) } />
                        <Route exact path={`${path}/relatorios`} render={props => withMenu(ConferenciaForm, {...props, path, ...conferenciaFormProps }) } />
                        <Route exact path={`${path}/relatorios/detalhamento`} render={props => <ConferenciaResult {...props } {...conferenciaResultProps} /> } />
                    </SwitchRouter>
                </Segment>                
            </div> 

            <AnimatedModal open={showModal}>
                <Modal open={true} dimmer='blurring' size='small' closeIcon onClose={() => closeModal()}>
                    <Modal.Header>Consulta situação na SEFAZ</Modal.Header>
                    <Modal.Content>
                        <div className="row">
                            <div className="col-3">
                                <strong>Empresa:</strong>
                            </div>
                            <div className="col">
                                {!!situacaoCupom && formSefaz.empresa !== '' && globalState.empresas.find(x => x && x._id === formSefaz.empresa).nomeEmpresa}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <strong>Chave de acesso:</strong>
                            </div>
                            <div className="col">
                                {!!situacaoCupom && situacaoCupom.chave_acesso}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <strong>Cupom:</strong>
                            </div>
                            <div className="col">
                                {!!situacaoCupom && situacaoCupom.numero_nota}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <strong>Emissão:</strong>
                            </div>
                            <div className="col">
                                {!!situacaoCupom && DateTime.fromFormat(situacaoCupom.emissao + "", "yyyyMMddHHmmss").toFormat('dd/MM/yyyy HH:mm:ss')}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <strong>Recebimento:</strong>
                            </div>
                            <div className="col">
                                {situacaoCupom && situacaoCupom.recebimento && DateTime.fromFormat(situacaoCupom.recebimento + "", "yyyyMMddHHmmss").toFormat('dd/MM/yyyy HH:mm:ss')}
                                {situacaoCupom && !situacaoCupom.recebimento && 'Sem informações'}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <strong>Situação:</strong>
                            </div>
                            <div className="col">
                                {situacaoCupom && situacaoCupom.situacao_sefaz}
                            </div>
                        </div>
                    </Modal.Content>
                </Modal>
            </AnimatedModal>     

        </PageLoader>
    )
}
